// extracted by mini-css-extract-plugin
export default {"title":"BlockTitle_title__DIgpU"};